module.exports = __webpack_public_path__ + "img/base_activites_activites_culturelles.e8d1dc68.svg";